module.exports = __webpack_public_path__ + "img/redirect.a211a714.png";